import { DataTableDesignTokens } from '@primeuix/themes/types/datatable';

export const DATA_TABLE_STYLES: DataTableDesignTokens = {
  headerCell: {
    padding: '0.625rem 0.875rem',
    sm: {
      padding: '0.328125rem 0.4375rem',
    },
  },
  bodyCell: {
    padding: '0.625rem 0.875rem',
    sm: {
      padding: '0.5rem 0.4375rem',
    },
  },
  footerCell: {
    padding: '0.625rem 0.875rem',
    sm: {
      padding: '0.328125rem 0.4375rem',
    },
  },
  css: ({ dt }) => `
    .p-datatable {
      font-size: 0.875rem;
    }

    .p-datatable-sm {
      font-size: 0.8125rem;
      line-height: normal;
    }

    .p-datatable-table .p-datatable-tfoot tr > td {
      border-width: 1px 0 0 0;
    }

    .p-datatable-tfoot > tr > td.p-datatable-frozen-column {
      background: ${dt('datatable.footer.cell.background')};
    }
        
    .p-datatable th,
    .p-datatable td {
      text-wrap: nowrap;
    }
      
    .p-datatable .p-paginator {
      width: 100%;
      align-self: start;

      .p-paginator-current {
        margin-left: auto;
        order: 4;
      }
    }

    .p-datatable:has(.p-paginator) {
      gap: 1rem;
    }

    .p-datatable-sm:has(.p-paginator) {
      gap: 0;
    }
      
    .p-datatable {
      --p-dt-frozen-shadow: 0 0 15px 0px rgba(81, 81, 81, 0.20);
      --p-dt-frozen-clip: 15px;
    }

    .p-datatable-table-container {
      container-type: scroll-state;
    }

    @container scroll-state(scrollable: x) {
      .p-datatable-frozen-column {
        box-shadow: var(--p-dt-frozen-shadow);
        clip-path: inset(0 0 0 calc(var(--p-dt-frozen-clip) * -1));

        &.p-datatable-frozen-column-left {
          clip-path: inset(0 calc(var(--p-dt-frozen-clip) * -1) 0 0);
        }
      }

      .p-datatable-frozen-column:not(.p-datatable-frozen-column-left) ~ .p-datatable-frozen-column:not(.p-datatable-frozen-column-left) {
        box-shadow: none;
        clip-path: none;
      }

      .p-datatable-frozen-column-left:has(~ .p-datatable-frozen-column-left) {
        box-shadow: none;
        clip-path: none;
      }
    }
      
    .p-datatable .p-paginator .p-select .p-select-label {
      font-size: 0.875rem !important;
      line-height: 0.875rem;
    }

    .p-datatable-sm .p-paginator {
      padding: 0;
    }

    .p-datatable-sm .p-paginator .p-paginator-page {
      min-width: 2.1875rem;
      width: auto;
      height: 2.1875rem;
    }

    .p-datatable-sm .p-paginator .p-select .p-select-label {
      font-size: 0.8125rem !important;
      line-height: 0.8125rem;
    }
      
    .p-datatable-mask {
      background-color: rgba(255, 255, 255, 0.9);
      color:  ${dt('primary.500')};
    }

    .p-datatable-gridlines .p-datatable-table {
      /* Remove outer table border */
      border: none;
    }

    .p-datatable-gridlines .p-datatable-thead > tr > th:first-child,
    .p-datatable-gridlines .p-datatable-tbody > tr > td:first-child,
    .p-datatable-gridlines .p-datatable-tfoot > tr > td:first-child {
      border-left-width: 0 !important;
    }

    .p-datatable-gridlines .p-datatable-thead > tr > th:last-child,
    .p-datatable-gridlines .p-datatable-tbody > tr > td:last-child,
    .p-datatable-gridlines .p-datatable-tfoot > tr > td:last-child {
      border-right-width: 0 !important;
    }

    .p-datatable-gridlines .p-datatable-tfoot > tr > td:last-child:not(.p-datatable-frozen-column) {
      border-left-width: 0 !important;
    }

    .p-datatable-gridlines .p-datatable-thead > tr:first-child > th {
      border-top-width: 0 !important;
    }

    .p-datatable.bordered-table {
      --p-dt-frozen-shadow: 0 0 8px 0px rgba(81, 81, 81, 0.15);
      --p-dt-frozen-clip: 8px;
      border-radius: 0.875rem;
      overflow: hidden;
      border: 1px solid ${dt('surface.200')};

      tfoot td:has(.p-paginator) {
        padding: 0 !important;
      }

      th {
        background-color: ${dt('surface.50')};
      }

      .p-paginator {
        border-radius: 0 0 0.875rem 0.875rem;
        padding: 0.5rem 1.25rem;
        border-top: 1px solid ${dt('surface.200')};

        button {
          height: 1.5rem;
          min-width: 1.5rem;
          width: 1.5rem;
        }

        .p-paginator-page {
          width: auto;
          padding-inline: 0.25rem;
        }

        .p-select-label {
          padding: 0.3125rem 0.4375rem;
        }

        .p-select-dropdown {
          width: 2rem;
        }
      }
    }

    .p-datatable.bordered-table:has(.p-paginator) tr:last-child > td,
    .p-datatable-table:has(.p-datatable-tfoot) tr:last-child > td  {
      border-bottom-width: 0;
    }

    .p-datatable-resizable-table > .p-datatable-tbody > tr > td:has(app-inline-edit-overlay-field) {
      overflow: visible;
    }
  `,
};
